import * as cookie from "cookie";
let lastCookieStr = "";
let lastCookies = {};
export function getCookieValue(cookieName) {
    const cookieStr = document.cookie;
    if (cookieStr !== lastCookieStr) {
        lastCookieStr = cookieStr;
        lastCookies = cookie.parse(cookieStr);
    }
    return cookieName in lastCookies ? lastCookies[cookieName] : null;
}
export function setCookie(cookieName, cookieValue, expires, domain) {
    document.cookie = cookie.serialize(cookieName, cookieValue, {
        path: "/",
        secure: false,
        domain: domain,
        expires: expires,
    });
}
//# sourceMappingURL=cookies.js.map